import React, {useEffect} from "react";
import InputLabel from "@mui/material/InputLabel";
import {FormControl, InputBase} from "@mui/material";
import { styled } from '@mui/material/styles';
import Select from '@mui/material/Select';
import {Colors} from "../../assets/colors/Colors";
import {isEmpty} from "../../util/is";
import {convertToString, validArray, validObjectKeys} from "../../util/functions";
import {Controller} from "react-hook-form";
import MenuItem from '@mui/material/MenuItem';
import { useTheme } from '@mui/material/styles';
import Tooltip from "@mui/material/Tooltip";


const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
      zIndex: 9999
    },
  },
};

function getStyles(item, list, theme, multiple) {

  if(multiple){
    return {
      fontWeight:
        list?.indexOf(convertToString(item)) !== -1
          ? theme.typography.fontWeightBold
          : theme.typography.fontWeightMedium,
    };
  }
  else{
    return {
      fontWeight:
          convertToString(list) === convertToString(item)
          ? theme.typography.fontWeightBold
          : theme.typography.fontWeightMedium,
    };
  }

}

const BootstrapInput = styled(InputBase)(({ theme }) => ({
  'label + &': {
    marginTop: theme.spacing(3),
  },
  '& .MuiInputBase-input': {
    borderRadius: 4,
    position: 'relative',
    backgroundColor: theme.palette.background.paper,
    border: '1px solid #ced4da',
    boxShadow: '0 2px 5px 0 rgb(0 0 0 / 4%)',
    fontSize: 16,
    padding: '8px 26px 8px 10px',
    transition: theme.transitions.create(['border-color', 'box-shadow']),
    fontFamily: [
      '-apple-system',
      'BlinkMacSystemFont',
      '"Segoe UI"',
      'Roboto',
      '"Helvetica Neue"',
      'Arial',
      'sans-serif',
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
    ].join(','),
    '&:focus': {
      borderRadius: 4,
      borderColor: '#1976d2'
    },
  },
}));

const SelectForm = ({identificador, label , value , options = [], handleChange, width = `100%`, disabled = false, className="classDefaultForm", required = false, inputProps = {},  customError = null, showId = true, multiple = false, readOnly = false, style ={}}) => {

    const theme = useTheme();

    const handleChangeController = (event, onChange) => {

      const { target: {value} } = event;

      if(multiple){
        if (value[value.length - 1] === "all") {
          let arrOptions = [];
          let optionsNew = (value.length - 1) === options.length ? [] : options
          for(let item of optionsNew){
            arrOptions.push(convertToString(item.id));
          }
          event.target.value = arrOptions.slice();
        }
      }

      onChange(event);

    }

    const onHandleChange = ({name, value}) => {

      if(multiple){
        if (value[value.length - 1] === "all") {
          let arrOptions = [];
          let optionsNew = (value.length - 1) === options.length ? [] : options
          for(let item of optionsNew){
            arrOptions.push(convertToString(item.id));
          }
          handleChange({name, value: arrOptions.slice()})
          return;
        }
      }

      handleChange({name, value})
    }

    return(
        <FormControl key={`key${identificador}`} variant="outlined" className={`my-1 ${className}`}>
          <Tooltip title={`${required ? `*${label}` : `${label}`}`}>
            <InputLabel shrink htmlFor={identificador} style={{width, fontWeight: 'bold', textOverflow: "ellipsis", overflow: "hidden", whiteSpace: "nowrap", pointerEvents: "auto"}}>{`${required ? `*${label}` : `${label}`}`}</InputLabel>
          </Tooltip>
            { !('control' in inputProps) ?
              <Select
                value={multiple ? validArray(value) : convertToString(value)}
                disabled={disabled}
                onChange={({target:{name, value}}) => onHandleChange({name, value})}
                inputProps={{
                  ...inputProps,
                  name: identificador,
                  readOnly
                }}
                displayEmpty
                multiple={multiple}
                className={`mx-1`}
                style={{marginTop: 9, marginBottom: 4, width, maxWidth: "100%", ...style}}
                input={<BootstrapInput />}
                MenuProps={MenuProps}
                renderValue={
                  multiple ? !isEmpty(value[0]) ? undefined : () => <div>Seleccione</div> : value !== "" ? undefined : () => <div>Seleccione</div>
                }
              >
                {
                  !multiple &&
                  <MenuItem
                    value={""}
                    style={getStyles("", value, theme, multiple)}
                  >
                    Seleccione
                  </MenuItem>
                }
                {
                  multiple && options?.length > 0 &&
                  <MenuItem
                    value="all"
                    style={getStyles("all", value, theme, multiple)}
                  >
                    Todos
                  </MenuItem>
                }
                {
                  options.map((item, index) => (
                    <MenuItem
                      key={index}
                      value={convertToString(item.id)}
                      style={getStyles(item.id, value, theme, multiple)}
                    >
                      {showId ? `${convertToString(item.id)} - ${item.text}` : item.text}
                    </MenuItem>
                  ))
                }
              </Select>
                :
                <Controller
                    rules={{ required: required }}
                    control={inputProps.control}
                    defaultValue={multiple ? [] : convertToString("")}
                    name={identificador}
                    render={({ field: { onChange, onBlur, value } }) =>
                        (<Select
                            value={multiple ? validArray(value) : convertToString(value)}
                            disabled={disabled}
                            onChange={(value) => handleChangeController(value, onChange)}
                            onBlur={onBlur}
                            inputProps={{
                                name: identificador,
                                readOnly
                            }}
                            displayEmpty
                            renderValue={
                              multiple ? !isEmpty(value[0]) ? undefined : () => <div>Seleccione</div> : value !== "" ? undefined : () => <div>Seleccione</div>
                            }
                            multiple={multiple}
                            className={`mx-1`}
                            style={{marginTop: 9, marginBottom: 4, width, maxWidth: "100%", ...style}}
                            input={<BootstrapInput />}
                            MenuProps={MenuProps}

                        >
                              {
                                !multiple &&
                                <MenuItem
                                  value={""}
                                  style={getStyles("", value, theme, multiple)}
                                >
                                  Seleccione
                                </MenuItem>
                              }
                              {
                                multiple && options?.length > 0 &&
                                <MenuItem
                                  value="all"
                                  style={getStyles("all", value, theme, multiple)}
                                >
                                  Todos
                                </MenuItem>
                              }
                              {
                                options.map((item, index) => (
                                  <MenuItem
                                    key={index}
                                    value={convertToString(item.id)}
                                    style={getStyles(item.id, value, theme, multiple)}
                                  >
                                    {showId ? `${convertToString(item.id)} - ${item.text}` : item.text}
                                  </MenuItem>
                                ))
                            }
                        </Select>)
                    }
                />
            }
            {
              (!isEmpty(customError) || required) &&
                <span className="mt-1 pl-2 titleForm panelColorError">{customError}</span>
            }
        </FormControl>
    )

}


export default SelectForm;
